import React from "react";
import AllPost from "../../sections/CustomerDashboard/Dashboard/AllPost";
import { AdminPageTitle } from "../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../components/common/Containers/DashboardMainContainer";
import { CUSTOMER_CENTERED_PAGE_TITLE_CLASS } from "../../sections/CustomerDashboard/shared/customerLayoutSpec";

const Posts = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${CUSTOMER_CENTERED_PAGE_TITLE_CLASS}`}>
        Posts
      </AdminPageTitle>
      <div className="min-h-screen">
        <AllPost />
      </div>
    </DashboardMainContainer>
  );
};

export default Posts;
